import questionTree from './src'
questionTree.install = (Vue) => {
  Vue.component(questionTree.name, questionTree)
}
export default questionTree



// WEBPACK FOOTER //
// ./packages/question-tree/index.js